<template>
    <ol class="ordered-list">
        <slot />
    </ol>
</template>
<script>
export default {
    name: 'OrderedList'
}
</script>